import DownloadHero from './Hero/DownloadHero';
import DownloadCarInfo from './CarInfo/DownloadCarInfo';

const DownloadCenterPage = ({ fields }) => {
  // 安全的字段提取函数
  const getFieldValue = (field) => {
    if (field?.value !== undefined) {
      return field.value;
    }
    return typeof field === 'string' ? field : '';
  };

  // 安全的数据映射，移除硬编码默认值
  const heroData = {
    image: fields?.heroImage || null,
    title: getFieldValue(fields?.heroTitle),
    text: getFieldValue(fields?.heroText),
  };

  // 处理车辆数据，适应不同的数据结构
  let carInfoData = fields?.carItem || fields?.downloadCenterCars || [];

  // 如果数据是直接的车辆数组，需要转换为分类格式
  if (carInfoData.length > 0 && !carInfoData[0]?.cars) {
    // 为每个车辆创建单独的分类
    carInfoData = carInfoData.map((car) => {
      const title = getFieldValue(car?.fields?.title) || car?.name || car?.displayName || '';
      return {
        id: car.id,
        title: title,
        cars: [car], // 每个分类只包含一个车辆
      };
    });
  }

  // 如果没有车辆数据，显示空状�?
  if (!carInfoData || carInfoData.length === 0) {
    return (
      <div className="container">
        <DownloadHero downloadCenterHero={heroData} />
        <div style={{ padding: '60px 20px', textAlign: 'center' }}>
          <h2></h2>
          <p></p>
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      <DownloadHero downloadCenterHero={heroData} />
      <DownloadCarInfo downloadCenterCars={carInfoData} />
    </div>
  );
};

export default DownloadCenterPage;
